import Cadastro from './Cadastro';
import Pessoal from './Pessoal';
import Afastamento from './Afastamento';
import Ambiente from './Ambiente';
import AvisoPrevio from './AvisoPrevio';
import Cargo from './Cargo';
import Cat from './Cat';
import Contrato from './Contrato';
import Deficiencia from './Deficiencia';
import Desligamento from './Desligamento';
import Estrangeiro from './Estrangeiro';
import FatorRisco from './FatorRisco';
import Horario from './Horario';
import Ponto from './Ponto';
import Reintegracao from './Reintegracao';
import Remuneracao from './Remuneracao';
import Rubrica from './Rubrica';
import Saude from './Saude';
import Treinamento from './Treinamento';

const Tabs = ({ tab, ...props }) => {
  switch (tab) {
    case 0:
      return <Cadastro {...props} />;
    case 1:
      return <Pessoal {...props} />;
    case 2:
      return <Afastamento {...props} />;
    case 3:
      return <Ambiente {...props} />;
    case 4:
      return <AvisoPrevio {...props} />;
    case 5:
      return <Cargo {...props} />;
    case 6:
      return <Cat {...props} />;
    case 7:
      return <Contrato {...props} />;
    case 8:
      return <Deficiencia {...props} />;
    case 9:
      return <Desligamento {...props} />;
    case 10:
      return <Estrangeiro {...props} />;
    case 11:
      return <FatorRisco {...props} />;
    case 12:
      return <Horario {...props} />;
    case 13:
      return <Ponto {...props} />;
    case 14:
      return <Reintegracao {...props} />;
    case 15:
      return <Remuneracao {...props} />;
    case 16:
      return <Rubrica {...props} />;
    case 17:
      return <Saude {...props} />;
    case 18:
      return <Treinamento {...props} />;

    default:
      return null;
  }
};

export default Tabs;
